<form #characteristicsForm="ngForm"
      id="char-scroll"
      class="flex-container tour-characteristics"
      *ngIf="feedstock && feedstock.characteristics">
  <div class="flex-container section-group-left flex-1">
    <!--unit value for TS-->
    <div class="section-item">
      <app-unit-value
        name="feedstock-ts-uv"
        units="Weight_Proportion"
        label="{{'PROJECT.FEEDSTOCK.CHARACTERISTICS.TS' | anessaTranslation: trigger}}"
        [labelFontSize]="this.translationService.getCurrentLang() === 'de' ? '16px': ''"
        flexStyle="column"
        [styleWhiteBoxes]="true"
        [setGreaterThanValue]="0"
        [(ngModel)]="feedstock.characteristics.ts"
        (ngModelChange)="onUnitValueChanged(propEnum.id_ts)"
        [autofillValue]="feedstock?.autofillPackage?.characteristicsPkg?.ts"
        [setCustomAutofillMessage]="'PROJECT.FEEDSTOCK.TYPE.DB_AUTOFILL_UV_HINT'"
        [inputPlaceholder]="('PROJECT.COMMON.PLEASE_ENTER' | anessaTranslation: trigger)"
        [dropdownPlaceholder]="('PROJECT.COMMON.CHOOSE' | anessaTranslation: trigger)"
      ></app-unit-value>
    </div>
    <!--unit value for VS-->
    <div class="section-item">
      <app-unit-value
        name="feedstock-vs-uv"
        units="Weight_Proportion_VS"
        label="{{'PROJECT.FEEDSTOCK.CHARACTERISTICS.VS' | anessaTranslation: trigger}}"
        flexStyle="column"
        [styleWhiteBoxes]="true"
        [setGreaterThanValue]="0"
        [(ngModel)]="feedstock.characteristics.vs"
        (ngModelChange)="onUnitValueChanged(propEnum.id_vs)"
        [autofillValue]="feedstock?.autofillPackage?.characteristicsPkg?.vs"
        [setCustomAutofillMessage]="'PROJECT.FEEDSTOCK.TYPE.DB_AUTOFILL_UV_HINT'"
        [inputPlaceholder]="('PROJECT.COMMON.PLEASE_ENTER' | anessaTranslation: trigger)"
        [dropdownPlaceholder]="('PROJECT.COMMON.CHOOSE' | anessaTranslation: trigger)"
      ></app-unit-value>
    </div>
    <!--unit value for density-->
    <div *ngIf="projectInputDisplay" class="section-item relative-container">
      <div class="toggle-position flex-container">
        <div class="flex-1">
          <mat-slide-toggle
            class=""
            (click)="densityToggleClicked()"
            [(ngModel)]="feedstock.characteristics.densityEnabled"
            (ngModelChange)="changesMadeNotifier.emit()"
            [name]="'density-toggle'"
          >{{'PROJECT.COMMON.ENABLE_TOGGLE' | anessaTranslation: trigger}}
          </mat-slide-toggle>
        </div>
        <div class="flex-1">
          <span class="material-icons spacer"
                [matTooltip]="('PROJECT.FEEDSTOCK.CHARACTERISTICS.DENSITY_TOOLTIP' | anessaTranslation: trigger)"
          >
            help
          </span>
        </div>
      </div>
      <div class="full-height">
        <app-unit-value
          name="feedstock-density-uv"
          [units]="'Density'"
          label="{{'PROJECT.FEEDSTOCK.CHARACTERISTICS.DENSITY' | anessaTranslation: trigger}}"
          flexStyle="column"
          [editable]="feedstock.characteristics.densityEnabled"
          [styleWhiteBoxes]="true"
          [(ngModel)]="feedstock.characteristics.density"
          (ngModelChange)="onUnitValueChanged(null)"
          [inputPlaceholder]="('PROJECT.COMMON.PLEASE_ENTER' | anessaTranslation: trigger)"
          [dropdownPlaceholder]="('PROJECT.COMMON.CHOOSE' | anessaTranslation: trigger)"
        ></app-unit-value>
      </div>
    </div>
  </div>
  <div *ngIf="projectInputDisplay" class="flex-container flex-1">
    <div class="section-item" style="flex: 1;">
      <h4 anessaTranslation="PROJECT.FEEDSTOCK.CHARACTERISTICS.BIOGAS_POTENTIAL.TITLE"></h4>
      <div
        (mouseenter)="showClearBiogasPotential = true"
        (mouseleave)="showClearBiogasPotential = false"
        class="relative-container">
        <mat-form-field floatLabel="never">
          <mat-select
            name="biogasPotentialOption"
            [(ngModel)]="selectedBiogasPotential"
            (ngModelChange)="onUnitValueChanged(null); setBmpData();"
            [placeholder]="('PROJECT.COMMON.PLEASE_SELECT' | anessaTranslation: trigger)">
            <mat-option
              *ngFor="let option of biogasPotentialOptions"
              [value]="option">
              {{ option | anessaTranslation: trigger }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <p
          *ngIf="selectedBiogasPotential && showClearBiogasPotential"
          class="form-field-clear"
          (click)="selectedBiogasPotential = null; setBmpData();">
          {{'PROJECT.COMMON.CLEAR' | anessaTranslation: trigger}}
        </p>
      </div>
      <div>
        <app-unit-value
          *ngIf="selectedBiogasPotential === biogasPotentialEnum.BIOGAS_YIELD"
          name="feedstock-bmp-yield-uv"
          [units]="'Gas_Yield_Per_Raw_Feedstock'"
          label="{{'PROJECT.FEEDSTOCK.CHARACTERISTICS.BIOGAS_POTENTIAL.BIOGAS_YIELD' | anessaTranslation: trigger}}"
          flexStyle="row"
          [styleWhiteBoxes]="true"
          [(ngModel)]="feedstock.bmpPotential.bmpYield.yield"
          (ngModelChange)="onUnitValueChanged(null); setBmpData();"
          [inputPlaceholder]="('PROJECT.COMMON.PLEASE_ENTER' | anessaTranslation: trigger)"
          [dropdownPlaceholder]="('PROJECT.COMMON.CHOOSE' | anessaTranslation: trigger)"
        ></app-unit-value>
        <app-unit-value
          *ngIf="selectedBiogasPotential === biogasPotentialEnum.BIOMETHANE_YIELD"
          name="feedstock-bmp-yield-uv"
          [units]="'CH4_Yield_Per_Raw_Feedstock'"
          label="{{'PROJECT.FEEDSTOCK.CHARACTERISTICS.BIOGAS_POTENTIAL.BIOMETHANE_YIELD' | anessaTranslation: trigger}}"
          flexStyle="row"
          [styleWhiteBoxes]="true"
          [(ngModel)]="feedstock.bmpPotential.bmpYield.yield"
          (ngModelChange)="onUnitValueChanged(null); setBmpData();"
          [inputPlaceholder]="('PROJECT.COMMON.PLEASE_ENTER' | anessaTranslation: trigger)"
          [dropdownPlaceholder]="('PROJECT.COMMON.CHOOSE' | anessaTranslation: trigger)"
        ></app-unit-value>
        <app-unit-value
          *ngIf="selectedBiogasPotential === biogasPotentialEnum.BMP"
          name="feedstock-bmp-direct-uv"
          [units]="'CH4_Volume'"
          label="{{'PROJECT.FEEDSTOCK.CHARACTERISTICS.BIOGAS_POTENTIAL.BMP' | anessaTranslation: trigger}}"
          flexStyle="row"
          [styleWhiteBoxes]="true"
          [(ngModel)]="feedstock.bmpPotential.bmpDirect.bmp"
          (ngModelChange)="onUnitValueChanged(null); setBmpData();"
          [inputPlaceholder]="('PROJECT.COMMON.PLEASE_ENTER' | anessaTranslation: trigger)"
          [dropdownPlaceholder]="('PROJECT.COMMON.CHOOSE' | anessaTranslation: trigger)"
        ></app-unit-value>
      </div>
    </div>
  </div>
  <!--density/cod toggles and unit value-->
  <div *ngIf="!projectInputDisplay" class="flex-container flex-1">
    <div class="section-item relative-container">
      <div class="toggle-position flex-container">
        <div class="flex-1">
          <mat-slide-toggle
            id="feedstock-characteristics-density_toggle"
            class=""
            (click)="densityToggleClicked()"
            [(ngModel)]="feedstock.characteristics.densityEnabled"
            (ngModelChange)="changesMadeNotifier.emit()"
            [name]="'density-toggle'"
          >{{'PROJECT.COMMON.ENABLE_TOGGLE' | anessaTranslation: trigger}}
          </mat-slide-toggle>
        </div>
        <div class="flex-1">
          <span class="material-icons spacer"
                [matTooltip]="('PROJECT.FEEDSTOCK.CHARACTERISTICS.DENSITY_TOOLTIP' | anessaTranslation: trigger)"
          >
            help
          </span>
        </div>
      </div>

      <!--unit value for density-->
      <div class="full-height">
        <app-unit-value
          name="feedstock-density-uv"
          [adjustOpacityOnDisable]="true"
          [units]="'Density'"
          label="{{'PROJECT.FEEDSTOCK.CHARACTERISTICS.DENSITY' | anessaTranslation: trigger}}"
          flexStyle="column"
          [editable]="feedstock.characteristics.densityEnabled"
          [styleWhiteBoxes]="true"
          [(ngModel)]="feedstock.characteristics.density"
          (ngModelChange)="onUnitValueChanged(null)"
          [inputPlaceholder]="('PROJECT.COMMON.PLEASE_ENTER' | anessaTranslation: trigger)"
          [dropdownPlaceholder]="('PROJECT.COMMON.CHOOSE' | anessaTranslation: trigger)"
        ></app-unit-value>
      </div>
    </div>
    <div class="section-item relative-container full-height">
      <div class="toggle-position flex-container">
        <div class="standard-height">
          <mat-slide-toggle
            id="feedstock-characteristics-cod_toggle"
            class=""
            (click)="codToggleClicked()"
            [(ngModel)]="feedstock.characteristics.codEnabled"
            (ngModelChange)="changesMadeNotifier.emit()"
            [name]="'cod-toggle'"
          >{{'PROJECT.COMMON.ENABLE_TOGGLE' | anessaTranslation: trigger}}
          </mat-slide-toggle>
        </div>
      </div>
      <div  class="full-height">
        <app-unit-value
          name="feedstock-characteristics-cod-uv"
          [adjustOpacityOnDisable]="true"
          units="COD_Perc_VS"
          label="{{'PROJECT.FEEDSTOCK.CHARACTERISTICS.COD' | anessaTranslation: trigger}}"
          flexStyle="column"
          [editable]="feedstock.characteristics.codEnabled"
          [styleWhiteBoxes]="true"
          [(ngModel)]="feedstock.characteristics.cod"
          (ngModelChange)="onUnitValueChanged(null); onCodChanged($event)"
          [inputPlaceholder]="('PROJECT.COMMON.PLEASE_ENTER' | anessaTranslation: trigger)"
          [dropdownPlaceholder]="('PROJECT.COMMON.CHOOSE' | anessaTranslation: trigger)"
        ></app-unit-value>
      </div>
    </div>
  </div>
</form>
